import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { buildHttpParams } from 'app/core/utils/http-util';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { EnumSituacaoCondicaoPagamento } from '../enums/situacao-condicao-pagamento.enum';
import { ICondicaoPagamentoFilter } from '../interfaces/condicao-pagamento-filter.interface';
import { ICondicaoPagamentoResponse } from '../interfaces/condicao-pagamento-response.interface';
import { ICondicaoPagamento, ICondicaoPagamentoPrazo } from '../interfaces/condicao-pagamento.interface';

export interface ICondicaoPagamentoPayload {
  nome: string;
  tipo: number;
  situacao: EnumSituacaoCondicaoPagamento;
  idFormaPagamento?: number;
  codigoIntegracaoErp: string;
  percCustoFinanceiro: number;
  prazos: ICondicaoPagamentoPrazo[];
}

@Injectable({ providedIn: 'root' })
export class CondicaoPagamentoApi {
  private apiUrl = `${environment.pathApi}/v1/environment/condicoes-pagamentos`;

  constructor(private http: HttpClient) {}

  search(filter: ICondicaoPagamentoFilter): Observable<ICondicaoPagamentoResponse> {
    return this.http.get<ICondicaoPagamentoResponse>(this.apiUrl, {
      params: buildHttpParams(filter),
    });
  }

  fetchList(filter?: ICondicaoPagamentoFilter): Observable<ICondicaoPagamentoResponse> {
    return this.http.get<ICondicaoPagamentoResponse>(`${this.apiUrl}/0/list`, {
      params: buildHttpParams(filter),
    });
  }

  load(id: number): Observable<ICondicaoPagamento> {
    return this.http.get<ICondicaoPagamento>(`${this.apiUrl}/${id}`);
  }

  create(payload: ICondicaoPagamentoPayload): Observable<ICondicaoPagamento> {
    return this.http.post<ICondicaoPagamento>(this.apiUrl, payload);
  }

  update(id: number, payload: ICondicaoPagamentoPayload): Observable<ICondicaoPagamento> {
    return this.http.put<ICondicaoPagamento>(`${this.apiUrl}/${id}`, payload);
  }

  updateSituacao(id: number, situacao: EnumSituacaoCondicaoPagamento): Observable<ICondicaoPagamento> {
    return this.http.put<ICondicaoPagamento>(`${this.apiUrl}/${id}/situacao`, { situacao });
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
